import React from 'react';
import { leadsStockPartialData } from '.';
import { MasInformacionForm } from '../MasInformacion';

export function StockForm() {
	return <MasInformacionForm updatedFormData={leadsStockPartialData} />;
}
